module.exports = __webpack_public_path__ + "static/media/nestjs.4da5bb9f.svg";